export class SourceStorage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "volumeCount",
            "baseName": "volumeCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "filesCount",
            "baseName": "filesCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "objectCount",
            "baseName": "objectCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "standardStorageSizeBytes",
            "baseName": "standardStorageSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sizeBytesByDataClass",
            "baseName": "sizeBytesByDataClass",
            "type": "{ [key: string]: number; }",
            "format": "int64"
        },
        {
            "name": "versioningEnabled",
            "baseName": "versioningEnabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceStorage.attributeTypeMap;
    }
    constructor() {
    }
}
